document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector(".splide");
  let options = {};

  if (!target || typeof Splide == undefined) return;

  if (target.classList.contains("splide--announcement")) {
    options = {
      type: "loop",
      arrows: false,
      pagination: false,
      autoplay: true
    };
  } else if (target.classList.contains("splide--reviews")) {
    options = {
      type: "slide",
      arrows: false,
      pagination: false,
      perPage: 3,
      gap: 35,
      padding: { right: 60 },
      breakpoints: {
        980: {
          perPage: 2,
          padding: { right: 45 },
          gap: 20
        },
        576: {
          perPage: 1,
          padding: { right: 45 },
          gap: 15
        }
      }
    };
  }

  let splide = new Splide(target, options);
  splide.mount();
});
